<div fxLayout="row" fxLayoutAlign="end center" class="header">
    <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content fxLayout="column">
    <h2 class="heading-2 title-text" matDialogTitle>{{previewTitle}}</h2>
    <div [innerHtml]="previewMessage"></div>
</div>
